import { useEffect } from 'react';
import { useLocation, useParams } from 'react-router-dom';
import { SUPPORTED_LANGS } from '@/i18n';
import { useTranslation } from 'react-i18next';

const BASE_URL = 'https://ismscalculator.com';

export function HreflangTags() {
  const { lang } = useParams();
  const { i18n } = useTranslation();
  const location = useLocation();

  const currentLang = lang && SUPPORTED_LANGS.includes(lang) ? lang : i18n.language || 'en';
  const pathWithoutLang = location.pathname.replace(/^\/[a-z]{2}/, '') || '/';

  useEffect(() => {
    // Set <html lang>
    document.documentElement.lang = currentLang;

    // Remove old tags we manage
    document.querySelectorAll('link[data-hreflang-managed]').forEach(el => el.remove());

    const head = document.head;

    // Add canonical
    const canonical = document.createElement('link');
    canonical.rel = 'canonical';
    canonical.href = `${BASE_URL}/${currentLang}${pathWithoutLang}`;
    canonical.setAttribute('data-hreflang-managed', 'true');
    head.appendChild(canonical);

    // Keep social URL in sync during SPA navigation. Never copy a share token
    // into social metadata: shared routes retain a neutral public-home URL.
    const ogUrl = document.querySelector('meta[property="og:url"]');
    if (ogUrl) ogUrl.setAttribute('content', pathWithoutLang.startsWith('/shared/')
      ? `${BASE_URL}/${currentLang}/` : canonical.href);

    // Add hreflang alternates
    SUPPORTED_LANGS.forEach((code) => {
      const link = document.createElement('link');
      link.rel = 'alternate';
      link.href = `${BASE_URL}/${code}${pathWithoutLang}`;
      link.setAttribute('hreflang', code);
      link.setAttribute('data-hreflang-managed', 'true');
      head.appendChild(link);
    });

    // Add x-default
    const xDefault = document.createElement('link');
    xDefault.rel = 'alternate';
    xDefault.href = `${BASE_URL}/en${pathWithoutLang}`;
    xDefault.setAttribute('hreflang', 'x-default');
    xDefault.setAttribute('data-hreflang-managed', 'true');
    head.appendChild(xDefault);

    return () => {
      document.querySelectorAll('link[data-hreflang-managed]').forEach(el => el.remove());
    };
  }, [currentLang, pathWithoutLang]);

  return null;
}
